import { render, staticRenderFns } from "./ActivityContainer.vue?vue&type=template&id=3bab25bc&scoped=true&"
import script from "./ActivityContainer.vue?vue&type=script&lang=js&"
export * from "./ActivityContainer.vue?vue&type=script&lang=js&"
import style0 from "./ActivityContainer.vue?vue&type=style&index=0&id=3bab25bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab25bc",
  null
  
)

export default component.exports